export default "__VITE_ASSET__DcvdXh4M__"